import Player from '@vimeo/player';
import React, {
  CSSProperties,
  forwardRef, Ref, useEffect, useImperativeHandle, useRef, useState
} from 'react';

type CommentVideoPlayerProps = {
  options: Player.Options;
  id?: string;
  className?: string;
  style?: CSSProperties;
  onPlay?: () => void;
  onEnded?: () => void;
  onReady?: () => void;
};

const CommentVideoPlayer = ({
  options, id = '', className = '', style, onPlay, onEnded, onReady
}: CommentVideoPlayerProps, ref: Ref<Player>): React.JSX.Element => {
  const [player, setPlayer] = useState<Player>(null);
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let currentPlayer: Player;
    const cookiesContainsFunctional =
      document.cookie.includes('__hs_cookie_cat_pref') && document.cookie.includes('functional');

    if (player) {
      player.destroy().then(() => {
        currentPlayer = new Player(playerRef.current, { ...options, dnt: !cookiesContainsFunctional });
        setPlayer(currentPlayer);
      }).catch(() => {});
    } else {
      currentPlayer = new Player(playerRef.current, { ...options, dnt: !cookiesContainsFunctional });
      setPlayer(currentPlayer);
    }

    return () => {
      if (currentPlayer) {
        currentPlayer.destroy().catch(() => {});
      }
    };
  }, [options]);

  useEffect(() => {
    if (player) {
      player.ready().then(() => { onReady?.(); }).catch(() => {});
      player.on('play', () => { onPlay?.(); });
      player.on('ended', () => { onEnded?.(); });
    }

    return () => {
      if (player) {
        player.off('play');
        player.off('ended');
      }
    };
  }, [player]);

  useImperativeHandle(ref, () => player);

  return (
    <div id={id} ref={playerRef} className={`comment-video-player ${className}`} style={style} />
  );
};

export default forwardRef(CommentVideoPlayer);
